import { Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "@/lib/theme";

// Pill toggle that swaps light/dark mode. Uses neon mint when dark to
// echo the brand palette.
export default function ThemeToggle({ className = "" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
      className={`relative h-9 w-9 rounded-full flex items-center justify-center transition-colors border ${
        isDark
          ? "border-mint/40 bg-ink text-mint hover:border-mint hover:text-neon"
          : "border-slate-300 bg-white text-slate-700 hover:border-slate-950 hover:text-slate-950"
      } ${className}`}
      data-testid="theme-toggle-btn"
    >
      {isDark ? <Moon size={15} weight="fill" /> : <Sun size={15} weight="fill" />}
    </button>
  );
}
